import { render, staticRenderFns } from "./ReturnSummary.vue?vue&type=template&id=9fa76bbe&"
import script from "./ReturnSummary.vue?vue&type=script&lang=js&"
export * from "./ReturnSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReturnSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa76bbe')) {
      api.createRecord('9fa76bbe', component.options)
    } else {
      api.reload('9fa76bbe', component.options)
    }
    module.hot.accept("./ReturnSummary.vue?vue&type=template&id=9fa76bbe&", function () {
      api.rerender('9fa76bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnSummary.vue"
export default component.exports